import { render, staticRenderFns } from "./AccountsCouponTable.vue?vue&type=template&id=05c7d715&lang=pug&"
import script from "./AccountsCouponTable.vue?vue&type=script&lang=js&"
export * from "./AccountsCouponTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports